import api from './api'

export const personalizationService = {
  /**
   * Get personalization form structure
   */
  async getForm() {
    return await api.get('/personalization/form')
  },

  /**
   * Submit personalization form
   * @param {Object} data - Form data with answers array
   * @param {Array} data.answers - Array of {field_id, value}
   */
  async submitForm(data) {
    return await api.post('/personalization/submit', data)
  },

  /**
   * Get current user's personalization data
   */
  async getMyPersonalization() {
    return await api.get('/personalization/my-data')
  },

  /**
   * Check personalization completion status
   */
  async checkStatus() {
    return await api.get('/personalization/check')
  },

  /**
   * Get list of available konselors
   */
  async getKonselors() {
    return await api.get('/konselors')
  },

  /**
   * Get mahasiswas assigned to a konselor
   * @param {string} konselorId - Konselor UUID
   */
  async getMahasiswasByKonselor(konselorId) {
    return await api.get(`/konselors/${konselorId}/mahasiswas`)
  },

  /**
   * Admin: Update user personal data
   * @param {string} userId - User UUID
   * @param {Object} data - Personal data (nim, prodi, fakultas, angkatan)
   */
  async updatePersonalData(userId, data) {
    return await api.put(`/users/${userId}/personal-data`, data)
  },

  /**
   * Admin: Assign konselor to mahasiswa
   * @param {string} mahasiswaId - Mahasiswa UUID
   * @param {string} konselorId - Konselor UUID
   */
  async assignKonselor(mahasiswaId, konselorId) {
    return await api.post(`/users/${mahasiswaId}/assign-konselor`, {
      konselor_id: konselorId
    })
  }
}
